import { CheckCircleOutlineOutlined } from "@mui/icons-material";
import { Alert, AlertTitle, Box, Modal, Typography } from "@mui/material";
import theme from "lib/theme";

interface LegacyPickupRequestConfirmationModalProps {
  open: boolean;
  onClose: () => void;
}

const modalContainerSx = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: "742px",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  pt: 4.5,
  px: 12,
  pb: 6,
  [theme.breakpoints.down("md")]: {
    px: 3,
  },
};

export default function LegacyPickupRequestConfirmationModal({
  open,
  onClose,
}: LegacyPickupRequestConfirmationModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="legacy-pickup-confirmation-title"
      aria-describedby="legacy-pickup-confirmation-description"
      sx={{ mx: 2 }}
    >
      <Box sx={modalContainerSx}>
        <Box sx={{ textAlign: "center" }}>
          <CheckCircleOutlineOutlined color="primary" sx={{ fontSize: "60px" }} />
          <Typography id="legacy-pickup-confirmation-title" mt={1} variant="h5" component="h2" fontWeight={800}>
            Our team is reviewing your pickup date request!
          </Typography>
          <Typography id="legacy-pickup-confirmation-description" mt={0.5} fontSize="20px">
            Your date isn&apos;t confirmed yet - our team is reviewing the size of your pickup and our availability.
            Reach out if you have any questions in the meantime!
          </Typography>
        </Box>

        <Box mt={2}>
          <Alert severity="info">
            <AlertTitle>Keep your pickup details up to date!</AlertTitle>
            Thanks for helping us keep old devices in circulation and preventing unnecessary e-waste! Make sure your
            pickup details are accurate up to 48 hours prior to the pickup date.
          </Alert>
        </Box>
      </Box>
    </Modal>
  );
}
